import { render, staticRenderFns } from "./averageCheckByUsername.vue?vue&type=template&id=3f1c9016&scoped=true"
import script from "./averageCheckByUsername.vue?vue&type=script&lang=js"
export * from "./averageCheckByUsername.vue?vue&type=script&lang=js"
import style0 from "./averageCheckByUsername.vue?vue&type=style&index=0&id=3f1c9016&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1c9016",
  null
  
)

export default component.exports